import RegistrationSmokeTestForm from "./RegistrationSmokeTestForm";

export default RegistrationSmokeTestForm;
